import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  FormControlLabel,
  Checkbox,
  TextField,
  Button,
  IconButton,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { getColorWithNewOpacity } from "./utlis";
import { Close } from "@mui/icons-material";

const DropdownPropertiesPanel = ({
  selectedAnnotation,
  onUpdateAnnotation,
  closeButton,
}) => {
  const [isRequired, setIsRequired] = useState(false);
  const [options, setOptions] = useState([]);
  const [newOption, setNewOption] = useState("");

  useEffect(() => {
    if (selectedAnnotation) {
      setIsRequired(selectedAnnotation.isRequired || false);
      setOptions(selectedAnnotation.options || []);
    }
  }, [selectedAnnotation]);

  const handleRequiredChange = (event) => {
    const newValue = event.target.checked;
    setIsRequired(newValue);
    onUpdateAnnotation({
      // ...selectedAnnotation,
      isRequired: newValue,
      backgroundColor: getColorWithNewOpacity(
        selectedAnnotation.signerColor,
        newValue
      ),
    });
  };

  const handleAddOption = () => {
    if (newOption.trim()) {
      const updatedOptions = [...options, newOption.trim()];
      setOptions(updatedOptions);
      setNewOption("");
      onUpdateAnnotation({
        ...selectedAnnotation,
        options: updatedOptions,
      });
    }
  };

  const handleDeleteOption = (index) => {
    const updatedOptions = options.filter((_, i) => i !== index);
    setOptions(updatedOptions);
    onUpdateAnnotation({
      ...selectedAnnotation,
      options: updatedOptions,
    });
  };

  return (
    <Box>
      {/* <Typography
        variant="h6"
        sx={{
          fontWeight: 600,
          fontSize: "16px",
          color: "rgba(0, 0, 0, 0.87)",
          mb: 2.5,
        }}
      >
        Dropdown
      </Typography> */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2.5,
          mt: 1,
          // px: 1,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            fontSize: "16px",
            color: "rgba(0, 0, 0, 0.87)",
            // mb: 2.5,
            width: "100%",
          }}
        >
          Dropdown
        </Typography>

        <Close
          style={{
            cursor: "pointer",
            color: "rgba(0, 0, 0, 0.54)",
            "&:hover": {
              color: "rgba(0, 0, 0, 0.87)",
            },
            fontSize: "20px",
          }}
          onClick={closeButton}
        />
      </Box>

      <FormControlLabel
        sx={{
          margin: 0,
          "& .MuiFormControlLabel-label": {
            margin: 0,
          },
        }}
        control={
          <Checkbox
            checked={isRequired}
            onChange={handleRequiredChange}
            size="small"
            sx={{
              color: "rgba(0, 0, 0, 0.54)",
              "&.Mui-checked": {
                color: "rgb(0, 145, 255)",
              },
              padding: "4px",
            }}
          />
        }
        label={
          <Typography
            variant="body2"
            sx={{
              fontSize: "13px",
              color: "rgba(0, 0, 0, 0.7)",
              ml: 0.5,
            }}
          >
            Required
          </Typography>
        }
      />

      <Box sx={{ mt: 2 }}>
        <Typography
          variant="body2"
          sx={{
            fontSize: "13px",
            color: "rgba(0, 0, 0, 0.7)",
            mb: 1,
          }}
        >
          Dropdown Options
        </Typography>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mb: 2 }}>
          <TextField
            fullWidth
            size="small"
            value={newOption}
            onChange={(e) => setNewOption(e.target.value)}
            placeholder="Add option"
            sx={{
              "& .MuiOutlinedInput-root": {
                fontSize: "14px",
                backgroundColor: "#fff",
                "&:hover fieldset": {
                  borderColor: "rgba(0, 145, 255, 0.5)",
                },
              },
            }}
          />
          <Button
            onClick={handleAddOption}
            variant="contained"
            size="small"
            startIcon={<AddIcon />}
            sx={{
              backgroundColor: "rgb(0, 145, 255)",
              "&:hover": {
                backgroundColor: "rgb(0, 125, 220)",
              },
            }}
          >
            Add
          </Button>
        </Box>

        <List dense>
          {options.map((option, index) => (
            <ListItem
              key={index}
              secondaryAction={
                <IconButton
                  edge="end"
                  onClick={() => handleDeleteOption(index)}
                  size="small"
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              }
              sx={{
                bgcolor: "background.paper",
                border: "1px solid rgba(0, 0, 0, 0.12)",
                borderRadius: 1,
                mb: 1,
              }}
            >
              <ListItemText
                primary={option}
                primaryTypographyProps={{
                  sx: { fontSize: "14px" },
                }}
              />
            </ListItem>
          ))}
        </List>
      </Box>
    </Box>
  );
};

export default DropdownPropertiesPanel;
